import * as React from 'react'
import Box from '@mui/material/Box'
import { ViewDetailsLink } from './ViewDetailsLink.styled'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { ViewDetailsText } from './ViewDetailsText.styled'
import IconButton from '@mui/material/IconButton'

type Props = {
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  open: boolean
}

export function ViewDetailsButton(props: Props) {
  const { onClick, open } = props
  return (
    <Box onClick={onClick}>
      <ViewDetailsLink underline="always">
        <ViewDetailsText display="inline">View Details</ViewDetailsText>
      </ViewDetailsLink>
      <IconButton aria-label="expand row" color="primary" size="small">
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    </Box>
  )
}
